module.exports = __webpack_public_path__ + "static/media/ic_circle_selected.8fd73c1a.svg";